module.exports = __webpack_public_path__ + "static/img/resource1.813ef6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/resource1.jpg
// module id = 4bPv
// module chunks = 1